import { RouteConfig } from 'vue-router'

import RHome from './RHome'
import RSportRecord from './RSportRecord'
import RCollegeRegist from './RCollegeRegist'
import RRunningRank from './RRunningRank'
import RCourseSelection from './RCourseSelection'
import RLeave from './RLeave'
import RAiSports from './RAiSports'
const Layout = () => import('../views/Layout.vue')

const layoutRoute: RouteConfig = {
  path: '/tzy-university',
  name: 'tzy_university',
  component: Layout,
  redirect: RHome[0],
  children: [
    ...RHome,
    ...RSportRecord,
    ...RCollegeRegist,
    ...RRunningRank,
    ...RCourseSelection,
    ...RLeave,
    ...RAiSports,
  ],
}

export default layoutRoute
